module.exports = __webpack_public_path__ + "img/svg - only table.b7fc75c2.svg";